import Coordinate from "./Coordinate";

export default class PolyCornerCoordinate extends Coordinate {
    constructor(provider, absX, absY, parent) {
        super(provider, absX, absY);
        this.parent = parent;
    }

    setRelations(xCoord, yCoord, oppositeCoord) {
        this.xCoord = xCoord;
        this.yCoord = yCoord;
        this.oppositeCoord = oppositeCoord;
    }

    drag(dx, dy) {
        this.move(dx, dy, true);
    }

    move(dx, dy, withUpdate = true) {
        if (dx == 0 && dy == 0) {
            return;
        }
        super.move(dx, dy);
        if (withUpdate) {
            this.xCoord.absX += dx;
            this.yCoord.absY += dy;
            this.parent.center.move(dx / 2, dy / 2);
            this.parent.coordinates.map(c => {
                c.absX = this.parent.absMinX + this.parent.absWidth * c.xRatio;
                c.absY = this.parent.absMinY + this.parent.absHeight * c.yRatio;
            })
            this.updateInputs();
            this.parent.row.updateImg();
        }
    }

    mouseOver() {
        if (!this.hovered()) {
            return false;
        }

        this.cursor.set(this.direction + '-resize');
        return true;
    }

    updateInputs() {
        let multiInput = this.getTab('info').input.multiInput;
        for (let i = 0; i < this.parent.length; i++) {
            let input = multiInput.getInput(i);
            input.value(this.parent.segmentLength(i));
        }
    }

    get direction() {
        return (this.absX >= this.parent.center.absX
            && this.absY >= this.parent.center.absY)
            || (this.absX <= this.parent.center.absX
                && this.absY <= this.parent.center.absY)
            ? 'nwse'
            : 'nesw';
    }
}
